/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Paper from "@mui/material/Paper";
import toTopImage from "../../assets/img/scrollToTop.svg";
import withScroll from "../../services/withScroll";
import { Box, Fade, useTheme } from "@mui/material";
// @ts-ignore we need to install @types/react-scroll but there are conflicting dependencies so try again later
import { scrollTopButtonStyle } from "./scrollTopButtonStyle";

type ScrollTopButtonProps = {
  scrollPosition: number;
};
const ScrollTopButton = ({ scrollPosition }: ScrollTopButtonProps) => {
  return (
    <Fade in={scrollPosition >= 1500} timeout={1000}>
      <Box sx={scrollTopButtonStyle.button}>
        <Paper
          elevation={8}
          sx={scrollTopButtonStyle.imageCircle}
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        >
          <img src={toTopImage} alt={"Scrolltop"} />
        </Paper>
      </Box>
    </Fade>
  );
};

export default withScroll(ScrollTopButton);
